<template>
  <v-row class="px-0 mt-10">
    <v-col cols="auto" class="my-3 py-0 px-6 px-sm-1 blogs-header card-border-radius">
      <h2 data-testid="all-blogs-heading" class="font-weight-bold text-center">
        Blogs
      </h2>
    </v-col>
    <v-col
        cols="12"
        data-testid="blogs-list"
        class="card-border-radius d-flex flex-column pa-10"
        style="background-color: #FFFFFF;"
    >
      <div class="d-flex flex-row" v-if="showCreateButton">
        <v-btn
            to="/blogs/create"
            v-if="!$vuetify.breakpoint.xs"
            :style="{
                  fontFamily: 'Monserat',
                  backgroundColor: '#0033AA',
                  color: '#FFFFFF',
                  width: $vuetify.breakpoint.xs ? '100%' : '18em',
                  marginLeft: $vuetify.breakpoint.xs ? '0' : 'auto'
                }"
        >
          + New Blog
        </v-btn>
      </div>
      <div v-if="blogs.length && !loading" class="d-flex flex-row flex-wrap justify-space-between" >
        <BlogCard
            v-for="(blog) in blogs"
            :key="blog.slug"
            :blog="blog"
        />
      </div>
      <div v-else class="d-flex flex-row flex-wrap justify-space-around">
        <v-skeleton-loader
            data-testid="v-skeleton-loader"
            v-for="x in 8"
            :key="x"
            class="my-3"
            type="card,article,list-item-avatar-three-line"
            :width="$vuetify.breakpoint.xs ? '99%' : '23%'"
        />
      </div>
      <div v-if="!loading && blogs.length">
        <infinite-loading spinner="waveDots" @infinite="fetchMoreBlogs">
          <div slot="no-results">
            <v-chip small text-color="primary">You have caught up</v-chip>
          </div>
          <div slot="no-more">
            <v-chip small text-color="primary">You have caught up</v-chip>
          </div>
        </infinite-loading>
      </div>
      <v-btn
            v-if="$vuetify.breakpoint.xs"
            color="primary"
            to="/blogs/create"
            fab
            dark
            fixed
            bottom
            left
        >
          <v-icon>
            mdi-plus
          </v-icon>
        </v-btn>
    </v-col>
    <v-col cols="12" v-if="!loading && !blogs.length">
      <NoData
          data-testid="empty-blogs-list"
          :image="emptyPage"
          :title="`No blogs published yet`"
      />
    </v-col>
  </v-row>
</template>

<script>
import Logo from "@/assets/guiomentorLogo.png";
import BlogCard from "@/components/BlogCard";
import NoData from "@/components/NoData";
import emptyPage from "@/assets/no_data.svg";
import InfiniteScroll from "@/mixins/InfiniteScroll";
import {mapGetters, mapMutations} from "vuex";

export default {
  mixins: [InfiniteScroll],
  metaInfo() {
    return {
      title: 'Guiomentor - All Blogs',
      url: window.location.href,
      meta: [
        {name: 'title', content: 'Guiomentor - Blogs'},
        {
          name: 'description',
          content: this.description
        },
        //Facebook
        {name: 'og:type', content: 'Website'},
        {name: 'og:title', content: "Guiomentor - Blogs"},
        {name: 'og:description', content: this.description},
        {name: 'og:image', content: this.logo},

        // Twitter
        {name: 'twitter:card', content: 'summary_large_image'},
        {name: 'twitter:url', content: window.location.href},
        {name: 'twitter:title', content: "Guiomentor - Blogs"},
        {name: 'twitter:description', content: this.description},
        {name: 'twitter:image', content: this.logo},
      ]
    }
  },
  components: {BlogCard, NoData},
  data: () => ({
    emptyPage,
    showLogOutDialog: false,
    drawerOpen: true,
    loading: false,
    logo: Logo,
    description: "Guiomentor is a platform directed to a niche of 10to 25 years old. Its objective is to help students to choose the best career or discipline for them according to their skills and part of interest ",
    limit: 6,
    offset: 6,
    fetchUrl: ""
  }),
  computed: {
    ...mapGetters({
      isAuthenticated: "auth/GET_IS_AUTHENTICATED",
      user: "auth/GET_USER",
      blogs: "blogs/GET_ALL_BLOGS"
    }),
    showCreateButton() {
      return this.user?.account_types?.filter(item => item.name === "MENTOR").length && this.isAuthenticated
    },
  },
  beforeMount() {
    this.fetchUrl = `blogs/posts/?limit=${this.limit}`
    this.loadBlogs()
  },
  methods: {
    ...mapMutations({
      SET_ALL_BLOGS: "blogs/SET_ALL_BLOGS"
    }),
    async loadBlogs() {
      try {
        this.loading = true
        const {data} = await this.axios.get(this.fetchUrl)
        this.SET_ALL_BLOGS(data.results)
        this.loading = false
      } catch (error) {
        this.loading = false
        this.$snackbar.showMessage({
          content: this.$t('errors.somethingWentWrongError'),
          color: "error",
        });
      }
    },
    fetchMoreBlogs($state) {
      this.infiniteHandler($state, "SET_ALL_BLOGS")
    }
  }
}
</script>
<style lang="scss" scoped>
@import "~vuetify/src/styles/settings/_variables";
.blogs-header {
  background-color: #FFFFFF;
  color: #0035B0;
}
.card-border-radius {
  border-radius: .5em;
}
.v-btn {
  text-transform: none !important;
  padding: 1.5em !important;
  font-size: 1.2em !important;
}
</style>
